/* PR4 – bez unapred izabrane veličine; poruka ako se doda u korpu bez veličine */
(function(){
  function sizeSet(pi){ return pi.querySelector('fieldset.elia-size-option'); }
  function init(pi){
    if(pi.dataset.prSize) return; pi.dataset.prSize='1';
    var fs=sizeSet(pi); if(!fs){ return; }
    var count=parseInt(fs.dataset.sizeCount||'0',10);
    var require=fs.dataset.requirePick!=='false';
    var fromUrl=/[?&]variant=\d+/.test(location.search);
    pi.dataset.sizePicked=(!require||count<=1||fromUrl)?'true':'false';
    pi.addEventListener('change',function(e){
      if(e.target&&e.target.closest&&e.target.closest('fieldset.elia-size-option')){
        pi.dataset.sizePicked='true';
        var err=pi.querySelector('.elia-pr-size-error'); if(err) err.hidden=true;
      }
    });
    /* tap na već izabranu veličinu (npr. S) ne pravi "change" – i to računamo kao izbor */
    pi.addEventListener('click',function(e){
      var lab=e.target.closest&&e.target.closest('fieldset.elia-size-option label'); if(!lab) return;
      var inp=document.getElementById(lab.htmlFor); if(inp&&inp.checked){ pi.dataset.sizePicked='true'; var err=pi.querySelector('.elia-pr-size-error'); if(err) err.hidden=true; }
    });
  }
  function block(e){
    var form=e.target; var fid=form&&form.getAttribute&&form.getAttribute('id'); if(!fid||fid.indexOf('product-form-')!==0) return;
    var pi=document.getElementById('MainProduct-'+fid.replace('product-form-',''))||form.closest('product-info');
    if(!pi||pi.dataset.sizePicked!=='false') return;
    e.preventDefault(); e.stopImmediatePropagation();
    var err=pi.querySelector('.elia-pr-size-error'); if(err) err.hidden=false;
    var fs=sizeSet(pi);
    if(fs){ fs.scrollIntoView({behavior:'smooth',block:'center'}); var first=fs.querySelector('input:not(.disabled):not(:disabled)')||fs.querySelector('input'); if(first) setTimeout(function(){ first.focus({preventScroll:true}); },400); }
  }
  document.addEventListener('submit',block,true);
  function run(){ document.querySelectorAll('product-info.elia-women-pdp').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
  document.addEventListener('shopify:section:load',run);
})();
/* PR6 – link "Kroj i detalji" kod veličina: otvara deo Kroj i skroluje do njega */
document.addEventListener('click',function(e){
  var a=e.target.closest&&e.target.closest('.elia-pr-fit-link'); if(!a) return;
  var id=a.getAttribute('href'); var cands=[document.querySelector(id+'-col'),document.querySelector(id)].filter(function(x){return x&&x.offsetParent!==null;}); var t=cands[0]||document.querySelector(id); if(!t) return;
  e.preventDefault(); if(t.tagName==='DETAILS') t.open=true;
  var y=t.getBoundingClientRect().top+window.scrollY-110;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({top:y,behavior:reduce?'auto':'smooth'});
});
/* Popravka: tap na "Dodaj u korpu" (ili traku na telefonu) dok se nova veličina još učitava
   (Shopify tada privremeno isključi dugme) – zapamti tap i dodaj čim dugme bude spremno. */
(function(){
  var pending=new WeakMap();
  function info(el){return el&&el.closest&&el.closest('product-info');}
  function btnOf(pi){return pi&&pi.querySelector('product-form [name="add"]');}
  document.addEventListener('change',function(e){
    var pi=info(e.target); if(!pi||!e.target.closest('variant-selects')) return;
    pending.set(pi,Date.now());
  },true);
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){
    subscribe(PUB_SUB_EVENTS.variantChange,function(ev){
      document.querySelectorAll('product-info').forEach(function(pi){ if(!ev||!ev.data||pi.dataset.section===ev.data.sectionId) pending.delete(pi); });
    });
  }
  function queue(pi){
    var b=btnOf(pi); if(!b||pi.dataset.prQueued) return; pi.dataset.prQueued='1';
    b.classList.add('loading'); var sp=b.querySelector('.loading__spinner'); if(sp) sp.classList.remove('hidden');
    var t0=Date.now();
    (function wait(){
      var bb=btnOf(pi);
      if(bb&&!bb.disabled&&bb.getAttribute('aria-disabled')!=='true'){ delete pi.dataset.prQueued; bb.classList.remove('loading'); if(sp) sp.classList.add('hidden'); bb.click(); return; }
      if(Date.now()-t0>6000){ delete pi.dataset.prQueued; if(bb){bb.classList.remove('loading'); if(sp) sp.classList.add('hidden');} return; }
      setTimeout(wait,80);
    })();
  }
  function isLoading(pi){ var t=pending.get(pi); return t&&Date.now()-t<6000; }
  /* dugme je isključeno tokom učitavanja: propusti klik do omotača da bismo ga uhvatili */
  var st=document.createElement('style'); st.textContent='product-info product-form button[name="add"][disabled],product-info elia-sticky-buy button[disabled]{pointer-events:none}'; document.head.appendChild(st);
  document.addEventListener('click',function(e){
    var wrap=e.target.closest&&e.target.closest('product-form .product-form__buttons'); var sticky=e.target.closest&&e.target.closest('elia-sticky-buy');
    if(!wrap&&!sticky) return;
    var pi=info(e.target); var b=btnOf(pi); if(!pi||!b) return;
    if(b.disabled&&isLoading(pi)){ e.preventDefault(); e.stopImmediatePropagation(); queue(pi); }
  },true);
})();
